<template>
  <div class="user">
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'readStatus'">
              {{ stateListData[scope.row[item.field]] }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <detailUserMessage v-on:getData="getData" ref="detailUserMessage"></detailUserMessage>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/messageCenter/userMessage.js';
  // import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import detailUserMessage from './detail';
  import tableMixins from '@/common/mixins/table.js';
  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      // SiruiSearch,
      detailUserMessage,
    },
    name: 'userMessage',
    data() {
      return {
        load: false,
        query: {
          messageTypeName: null,
        },
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'title',
            title: 'messageType.table.title',
            visible: true,
          },
          { field: 'content', title: 'messageType.table.content', visible: true },
          { field: 'readStatus', title: 'messageType.table.readStatus', visible: true },
          { field: 'sendTime', title: 'messageType.table.sendTime', visible: true },
        ],
        tableData: [],
        rowData: {},
        stateListData: { 0: this.$t('message.no'), 1: this.$t('message.yes') },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'del') {
          this.delMessage();
        }
      },
      //删除
      delMessage() {
        if (this.multipleSelection.length === 0) {
          this.noSelectData();
        } else if (this.multipleSelection.length > 1) {
          this.onlyOneSelect();
        } else {
          this.$confirmAction()
            .then(() => {
              this.$axios
                .post(API.USER_MESSAGE_DEL_API, { id: this.multipleSelection[0].id })
                .then((res) => {
                  if (0 != res.data.code) {
                    //如果有错误返回，提示信息
                    this.$alert(res.data.msg);
                  } else {
                    this.getData();
                    this.$message({
                      type: 'success',
                      message: this.$t('message.success'),
                    });
                  }
                });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      //双击查看详情
      dblclickEvent(row) {
        this.$refs.detailUserMessage.openDialog(true, row.row.id);
      },
      //获取数据
      getData() {
        let query = {};
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        query.channel = 'FSQD01';
        this.load = true;
        this.$axios.post(API.USER_MESSAGE_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
            });
          }
        });
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //没有选择数据提示
      noSelectData() {
        this.$message({
          showClose: true,
          message: this.$t('xTable.noSelectData'),
          type: 'error',
        });
      },
      onlyOneSelect() {
        this.$message({
          showClose: true,
          message: this.$t('xTable.onlyOneSelect'),
          type: 'error',
        });
      },
      /**页面必要代码End */
    },
  };
</script>
<style lang="scss" scoped>
  .user {
    height: 100%;
    box-sizing: border-box;
  }
</style>
